/**
 * Cursor PAT (Personal Access Token) API Client
 */

import { fetchWithAuth } from './core'

export interface CursorToken {
  id: string
  name: string
  created_at: string | null
  last_used_at: string | null
  expires_at: string | null
  scopes: string[]
  last_used_ip: string | null
  usage_count: number
}

export interface CreateTokenRequest {
  name: string
}

export interface CreateTokenResponse {
  id: string
  name: string
  token: string // Only returned once
  created_at: string
  expires_at: string
  scopes: string[]
}

/**
 * Generate a new Cursor PAT
 */
export async function createCursorToken(request: CreateTokenRequest): Promise<CreateTokenResponse> {
  const response = await fetchWithAuth('/api/settings/cursor/tokens', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || 'Failed to create token')
  }
  
  return response.json()
}

/**
 * List all Cursor PATs for the current user
 */
export async function listCursorTokens(): Promise<CursorToken[]> {
  const response = await fetchWithAuth('/api/settings/cursor/tokens')
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || 'Failed to list tokens')
  }
  
  return response.json()
}

/**
 * Revoke a Cursor PAT
 */
export async function revokeCursorToken(tokenId: string): Promise<void> {
  const response = await fetchWithAuth(`/api/settings/cursor/tokens/${tokenId}`, {
    method: 'DELETE',
  })
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || 'Failed to revoke token')
  }
}
